<script setup>
    import { computed, defineProps, defineEmits } from "vue";

    const props = defineProps({
        total: { type: Number, required: true },
        per_page: { type: Number, default: 10 },
        last_page: { type: Number, default: 1 },
        modelValue: { type: Number, default: 1 },
        maxVisible: { type: Number, default: 3 },
        white: { type: Boolean, default: false }
    });

    const emit = defineEmits(["update:modelValue"]);

    const currentPage = computed({
        get: () => props.modelValue,
        set: (val) => {
            emit("update:modelValue", val);
        }
    });

    const totalPages = computed(() => props.last_page);

    const pages = computed(() => {
        const total = totalPages.value;
        const maxVisible = props.maxVisible;
        let start = Math.max(currentPage.value - Math.floor(maxVisible / 2), 1);
        let end = start + maxVisible - 1;

        if (end > total) {
            end = total;
            start = Math.max(end - maxVisible + 1, 1);
        }

        const arr = [];
        for (let i = start; i <= end; i++) arr.push(i);
        return arr;
    });

    function changePage(page) {
        if (page >= 1 && page <= totalPages.value) {
            currentPage.value = page;
        }
    }
</script>

<template>
    <div class="pagination sm justify-content-left mb-0 my-4"><!--white-->
        <button type="button" class="page-link" @click="changePage(currentPage - 1)" :class="{'active': currentPage === 1 }"><!--active -->
            <img src="/public/icons/icon-pagination-prev.svg" class="pagination-icon" alt="" />
            Précedent
        </button>
        <button type="button" class="page-link" @click="changePage(page)"  v-for="page in pages" :key="page" :class="{'active': currentPage === page }">{{ page }}</button>
        <button type="button" class="page-link pl-4" @click="changePage(currentPage + 1)" :class="{'active': currentPage === totalPages }">
            Suivant
            <img src="/public/icons/icon-pagination-next.svg" class="pagination-icon ml-2" alt="" />
        </button>
    </div>
</template>
